function resolveApiBase() {
  const env = (process.env.REACT_APP_API_URL || '').replace(/\/$/, '');

  if (typeof window === 'undefined') return env;

  const host = window.location.hostname;

  // CRA dev proxy
  if (host === 'localhost' || host === '127.0.0.1') return '';

  // Production site: API runs on same origin (Vercel serverless /api/*)
  if (host === 'www.gumballbuddies.com' || host === 'gumballbuddies.com') {
    return '';
  }

  // API-only host
  if (host === 'api.gumballbuddies.com') return '';

  return env;
}

const API_BASE = resolveApiBase();

function getToken() {
  return localStorage.getItem('gb_admin_token');
}

function asList(data) {
  return Array.isArray(data) ? data : [];
}

async function request(path, options = {}) {
  const headers = { ...options.headers };
  if (options.body && !(options.body instanceof FormData)) {
    headers['Content-Type'] = 'application/json';
  }

  const token = getToken();
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_BASE}${path}`, { ...options, headers });
  const contentType = res.headers.get('content-type') || '';
  const isJson = contentType.includes('application/json');
  const data = isJson ? await res.json().catch(() => null) : null;

  if (!res.ok) {
    const msg = data?.error || `Request failed (${res.status})`;
    throw new Error(msg);
  }
  if (!isJson) {
    throw new Error('Expected JSON response from API');
  }
  if (data === null) {
    throw new Error('Invalid JSON response');
  }
  return data;
}

export const publicApi = {
  getContent: () => request('/api/public/content'),
  getAnnouncements: (category) => {
    const q = category ? `?category=${encodeURIComponent(category)}` : '';
    return request(`/api/public/announcements${q}`).then(asList);
  },
  getMedia: (category) => {
    const q = category ? `?category=${encodeURIComponent(category)}` : '';
    return request(`/api/public/media${q}`).then(asList);
  },
};

export const authApi = {
  login: (username, password) =>
    request('/api/auth/login', { method: 'POST', body: JSON.stringify({ username, password }) }),
  me: () => request('/api/auth/me'),
};

export const adminApi = {
  getStats: () => request('/api/admin/stats'),
  getAnnouncements: () => request('/api/admin/announcements'),
  createAnnouncement: (data) =>
    request('/api/admin/announcements', {
      method: 'POST',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  updateAnnouncement: (id, data) =>
    request(`/api/admin/announcements/${id}`, {
      method: 'PUT',
      body: data instanceof FormData ? data : JSON.stringify(data),
    }),
  deleteAnnouncement: (id) => request(`/api/admin/announcements/${id}`, { method: 'DELETE' }),
  getRoadmap: () => request('/api/admin/roadmap'),
  createRoadmap: (data) => request('/api/admin/roadmap', { method: 'POST', body: JSON.stringify(data) }),
  updateRoadmap: (id, data) => request(`/api/admin/roadmap/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteRoadmap: (id) => request(`/api/admin/roadmap/${id}`, { method: 'DELETE' }),
  getHomepage: () => request('/api/admin/homepage'),
  updateHomepage: (id, data) => request(`/api/admin/homepage/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  getSocials: () => request('/api/admin/socials'),
  createSocial: (data) => request('/api/admin/socials', { method: 'POST', body: JSON.stringify(data) }),
  updateSocial: (id, data) => request(`/api/admin/socials/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteSocial: (id) => request(`/api/admin/socials/${id}`, { method: 'DELETE' }),
  getMedia: () => request('/api/admin/media'),
  uploadMedia: (formData) => request('/api/admin/media', { method: 'POST', body: formData }),
  updateMedia: (id, data) => request(`/api/admin/media/${id}`, { method: 'PUT', body: JSON.stringify(data) }),
  deleteMedia: (id) => request(`/api/admin/media/${id}`, { method: 'DELETE' }),
};
